import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";
import Switch from "react-switch";
import { Button, ButtonGroup, Col, Input, Label, Row, Table } from "reactstrap";
import { ItemDropdownMenu } from ".";
import { api, dateHelpers, helpers, UserContext } from "../utils";

export default function WarehouseShippingScheduleSampleOrderGrid(props) {
  const { currentUser } = useContext(UserContext);
  const [data, setData] = useState();
  const [editAllLineDates, setEditAllLineDates] = useState(false);
  const [editCopy, setEditCopy] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [total, setTotal] = useState(0);
  const [working, setWorking] = useState(false);
  const canEdit = currentUser?.isAPUCS || currentUser?.isWarehouseEdit || currentUser?.isPurchasingEdit;

  useEffect(() => {
    if (data !== props.data) {
      setData(props.data);
      setTotal(props.data.reduce((total, currentItem) => total = total + currentItem.extendedPrice, 0));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data])

  function allowEdit(index) {
    setEditIndex(index);
    setEditCopy(_.assign({}, props.data[index]));
  }

  function cancelEdit() {
    setEditIndex(null);
    setEditCopy(null);
    setEditAllLineDates(false);
  }

  function getExcel() {
    setWorking(true);
    props.exportXlsxCallback();
    setWorking(false);
  }

  function handleChange(field, value) {
    const copyUpdate = _.assign({}, editCopy);
    copyUpdate[field] = value;
    setEditCopy(copyUpdate);
  }

  function updateOrderLine() {
    setWorking(true);
    const payload = _.chain({})
      .assign(editCopy)
      .pickBy((_v, k) => editCopy[k] !== props.data[editIndex][k])
      .value();
    if (payload.requiredShipDate) {
      payload["editAllLineDates"] = editAllLineDates;
    }

    if (_.keys(payload).length) {
      payload["orderId"] = editCopy.orderId;
      payload["itemNumber"] = editCopy.itemNumber;
      payload["requiredShipDate"] = editCopy.requiredShipDate; 

      api
        .post(`Customer/UpdateOrderLine`, payload)
        .then((response) => {
          if (response.data.success) {
            props.onUpdateRow();
          } else {
            if (_.isString(response?.data?.message)) {
              toast.error(response?.data?.message);
            }
          }
        })
        .catch(api.catchHandler)
        .finally(() => {
          cancelEdit();
        });
    } else {
      cancelEdit();
    }
    setWorking(false);
  }

  function validateEditCopy() {
    if (editCopy === null) {
      return false;
    }
    if (!editCopy.requiredShipDate) {
      //PLAY.dbo.SOP10200
      return true;
    }
    return false;
  }

  return (
    <>
      <Row className="align-items-center">
        <Col className="transparent-background">
          <ButtonGroup className="float-end">
            {props.data && props.data.length && props.exportXlsxCallback && (
              <Button
                title="Download as .xlsx"
                className="shredButtonExcel float-end ms-2"
                onClick={getExcel}
                disabled={working}
              >
                <FontAwesomeIcon icon="file-excel" size="lg" />
              </Button>
            )}
          </ButtonGroup>
        </Col>
      </Row>
      <Table size="sm" className="data-table">
        <thead className="table-header">
          <tr>
            <th style={{ width: "10%" }}>
              <span>Order <br /> Number</span>
            </th>
            <th style={{ width: "5%" }}>
              <span>Order <br /> Date</span>
            </th>
            <th style={{ width: "15%" }}>
              <span>Customer</span>
            </th>
            {!currentUser?.isAnyCustomerTypeRole
              ? <th style={{ width: "10%" }}>
                <span>Item</span>
              </th>
              : null}
            <th style={{ width: "10%" }}>
              <span>Required Ship <br /> Date</span>
            </th>
            <th style={{ width: "5%" }}>
              <span>Order <br /> Qty</span>
            </th>
            <th style={{ width: "5%" }}>
              <span>BO <br /> Qty</span>
            </th>
            <th style={{ width: "5%" }}>
              <span>App <br /> Qty</span>
            </th>
            <th style={{ width: "10%" }}>      {/* Not sure why labeled Ext Price here */}
              <span>Ext Price</span>
            </th>
            <th>
                <span>Freight Carrier</span>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {_.map(props.data, (datum, index) => {
            const isEditing = editIndex === index;
            const readOnly = !isEditing;
            const shipDate = isEditing
              ? dateHelpers.formatDateForServer(editCopy.requiredShipDate)
              : dateHelpers.toLongDateString(datum.requiredShipDate);
            //const shipDateJSFormat = new Date(`${datum.requiredShipDate}`);
            return (
              <tr
                key={index}
                className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
              >
                <td className="data-cell" children={datum.orderId} />
                <td
                  className="data-cell"
                  children={dateHelpers.toLongDateString(datum.documentDate)}
                />
                <td
                  className="data-cell"
                >                  
                  <Link
                  style={{textDecoration: "none"}}
                  className="shredLink fw-bold"
                  to={`/customer-dashboard/${datum.customerId}`}
                  >
                    {datum.customerIdNameShipCity}
                  </Link>
                </td>
                {/* {!currentUser?.isAnyCustomerTypeRole
                  ?  */}
                <ItemDropdownMenu
                  itemNumber={datum.itemNumber}
                  itemDescription={datum.itemWithDesc}
                  attachmentCount={null}
                  customerId={datum.customerId}
                />
                {/* : null} */}
                <td className="data-cell">
                  {isEditing
                    ? (<Fragment>
                      <Row>
                        <Col>
                          <Input
                            type="date"
                            onChange={(e) => handleChange("requiredShipDate", e.target.value)}
                            value={shipDate}
                            style={{ fontSize: "1em" }}
                          />
                        </Col>
                      </Row>
                      <Row className='align-items-center'>
                        <Col xs={3}>
                          <Switch
                            className="mt-3"
                            height={20}
                            width={48}
                            checked={editAllLineDates}
                            onChange={() =>
                              setEditAllLineDates(!editAllLineDates)
                            }
                          />
                        </Col>
                        <Col xs={9}>
                          <Label
                            className="pt-2 ps-2 pb-0 mb-0 "
                            children="Update date on all line items"
                          />
                        </Col>
                      </Row>
                    </Fragment>)
                    : (<span>{shipDate}</span>)
                  }
                </td>
                <td className="data-cell" children={datum.qtyRemaining.toLocaleString()} />
                <td className="data-cell" children={datum.qtyBackOrdered.toLocaleString()} />
                <td className="data-cell" children={datum.qtyFullfilled.toLocaleString()} />
                <td className="data-cell" children={helpers.formatCurrency(datum.extendedPrice)} />
                <td className="data-cell" children={datum.shipperNamePhone} />
                {canEdit && (
                  <td className="data-cell">
                    <ButtonGroup className="width95px">
                      <Button
                        className={`icon-button me-1 ${isEditing ? '' : 'float-end'}`}
                        title={isEditing ? "Save changes" : "Edit line"}
                        color={isEditing ? "success" : "info"}
                        onClick={
                          isEditing
                            ? updateOrderLine
                            : () => allowEdit(index)
                        }
                        disabled={
                          (editIndex !== null && readOnly) ||
                          validateEditCopy() ||
                          working
                        }
                      >
                        <FontAwesomeIcon
                          className="whiteIcon"
                          icon={isEditing ? "check" : "edit"}
                        />
                      </Button>
                      <Button
                        className={`icon-button ${isEditing ? "" : "vis-hidden"}`}
                        color="secondary"
                        title="Discard changes"
                        onClick={cancelEdit}
                        disabled={editIndex !== null && readOnly}
                      >
                        <FontAwesomeIcon className="whiteIcon" icon="times" />
                      </Button>

                    </ButtonGroup>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
        {/* <tfoot className="table-footer">
          <tr>
            <td colSpan={"8"}></td>
            <td className={`fw-bold`}>
              {helpers.formatCurrency(total)}
            </td>
            <td></td>
          </tr>
        </tfoot> */}
      </Table>
    </>
  );
}
